<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }} {{is_required ? '*' :'' }}</label>
        <input :id="id" ref="input" v-bind="{ ...$attrs, class: null }" v-maska:[maskOptions] class="form-input" :class="{ error: error }" :type="type" :placeholder="placeholder" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" @maska="onMaska" />
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import { vMaska } from 'maska'

export default {
    inheritAttrs: false,
    directives: { maska: vMaska },
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        error: String,
        label: String,
        is_required: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        modelValue: String,
        mask: {
            type: [String, Array, Object],
            default: null,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        maskOptions() {
            if (!this.mask) return undefined
            if (typeof this.mask === 'string') {
                return { mask: this.mask }
            }
            if (Array.isArray(this.mask)) {
                return { mask: this.mask }
            }
            return this.mask
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
        onMaska(event) {
            if (this.mask) {
                this.$emit('update:modelValue', event.target.value)
            }
        },
    },
}
</script>
